import { all, takeLatest } from 'redux-saga/effects';
import { fetchPromoSearchTags } from 'store/promoSearchTags/actions';
import fetchPromoSearchTagsWorker from './worker.fetchPromoSearchTags';

function* promoSearchTagsSaga() {
  yield all([takeLatest(fetchPromoSearchTags, fetchPromoSearchTagsWorker)]);
}

export default promoSearchTagsSaga;
